import { useMemo } from 'react';

export default function useArtistEventListConditionChips({
  fetchEvents,
  filterEndDate,
  filterEventName,
  filterGenres,
  filterPrefectures,
  filterRegions,
  filterStartDate,
  filterVenues,
  genreMap,
  regionLabelMap,
  removeGenreSelection,
  removePrefectureSelection,
  removeRegionSelection,
  removeVenueSelection,
  setAutoRange,
  setFilterEndDate,
  setFilterEventName,
  setFilterStartDate,
  venuesById,
}) {
  return useMemo(() => {
    const chips = [];

    if (filterStartDate || filterEndDate) {
      const from = filterStartDate || '未設定';
      const to = filterEndDate || '未設定';
      chips.push({
        key: 'period',
        label: `期間: ${from}〜${to}`,
        onRemove: () => {
          setFilterStartDate('');
          setFilterEndDate('');
          setAutoRange('auto');
          fetchEvents({});
        },
      });
    }

    if (filterEventName.trim()) {
      chips.push({
        key: 'keyword',
        label: `キーワード: ${filterEventName.trim()}`,
        onRemove: () => setFilterEventName(''),
      });
    }

    filterGenres.forEach((value) => {
      const label = genreMap.get(String(value))?.label || value;
      chips.push({
        key: `genre-${value}`,
        label,
        onRemove: () => removeGenreSelection(value),
      });
    });

    filterRegions.forEach((value) => {
      const label = regionLabelMap.get(value) || value;
      chips.push({
        key: `region-${value}`,
        label,
        onRemove: () => removeRegionSelection(value),
      });
    });

    filterPrefectures.forEach((value) => {
      chips.push({
        key: `pref-${value}`,
        label: value,
        onRemove: () => removePrefectureSelection(value),
      });
    });

    filterVenues.forEach((venueId) => {
      const label = venuesById.get(String(venueId))?.name || venueId;
      chips.push({
        key: `venue-${venueId}`,
        label,
        onRemove: () => removeVenueSelection(venueId),
      });
    });

    return chips;
  }, [
    fetchEvents,
    filterEndDate,
    filterEventName,
    filterGenres,
    filterPrefectures,
    filterRegions,
    filterStartDate,
    filterVenues,
    genreMap,
    regionLabelMap,
    removeGenreSelection,
    removePrefectureSelection,
    removeRegionSelection,
    removeVenueSelection,
    setAutoRange,
    setFilterEndDate,
    setFilterEventName,
    setFilterStartDate,
    venuesById,
  ]);
}
